import { useCallback } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
export const createUseAction = (action, statePath) => (config) => {
    const status = useSelector(state => action.selectors.getStatus(statePath(state), config), shallowEqual);
    const error = useSelector(state => action.selectors.getError(statePath(state), config), shallowEqual);
    const value = useSelector(state => action.selectors.getResponse(statePath(state), config), shallowEqual);
    const dispatch = useDispatch();
    const start = useCallback(body => {
        dispatch(action.actions.start(config, body));
    }, [config]);
    return { status, error, value, start };
};
//# sourceMappingURL=actionHooks.js.map